module.exports = __webpack_public_path__ + "static/media/about-img.67b9d7e2.png";